import { eCommercePlatform } from "@/model/Constants";

export const optOutQueueMessage: any = {
  all: 'Dealer is not accepting the transfer from all stores',
  store: 'Dealer is not accepting the transfer from this store'
};


export const optOutExploreMessage: any = {
  all: 'Cannot initiate transfer as dealer has opted out for all stores',
  store: 'Cannot initiate transfer as dealer has opted out for this store'
};

export const optoutMessages = {
  store: 'Just this store',
  all: 'All stores'
};

export const optinMessages = {
  opt_in_all: 'All stores',
  opt_in_store: 'Just this store'
};

export const jusThisStoreValues = {
  store: 'Just this store',
  opt_in_store: 'Just this store'
};

export const allStoreValues = {
  opt_in_all: 'All stores',
  all: 'All stores'
};
export const sotUnderReviewMessage = 'SOT is under review';
export const LOAUnderReviewMessage = 'LOA is under review';
export const fileUploadMessage = 'File is successfully uploaded';
export const fileUploadDescription = 'It will be reviewed first before being added to your profile.';
export const phoneLabels = {
  work: 'Work',
  home: 'Home',
  fax: 'Fax',
  mobile: 'Mobile',
  other: 'Other'
};

export const businessPhoneLabels = {
  phone_label_work: 'Work',
  phone_label_home: 'Home',
  phone_label_fax: 'Fax',
  phone_label_mobile: 'Mobile',
  phone_label_other: 'Other'
};

export const inboundTransferMacroStatus: any = {
  inbound_transfer_pending: 'Pending',
  inbound_transfer_awaiting_item: "Awaiting Item",
  inbound_transfer_item_received: "Item Received",
  inbound_transfer_complete: "Inbound Transfer Complete",
  inbound_transfer_failed: "Inbound Transfer Failed",
}

export const transferMacrostatus: any = {
  tranfer_pending: 'Pending',
  transfer_initiated: 'Transfer initiated',
  initiation_email_sent: 'Email Processing',
  waiting_for_email: 'Email Processing',
  waiting_dealer_action: 'Dealer Action',
  waiting_license_validation: 'Document Processing',
  outbound_transfer_confirmed: 'First Time Confirmation Delay',
  outbound_transfer_complete: 'Transfer Completion',
  outbound_transfer_failed: 'Outbound Transfer Failed',
  new_dealer_assigned: "New Dealer Assigned",
  in_progress: "In Progress",
  ...inboundTransferMacroStatus
};

export const transferTips = {
  waiting_for_mturk: 'Our automations are working on finding the email.',
  email_not_found: 'Reach out to customer and select a new FFL provider.',
  opted_out: 'Reach out to customer and select a new FFL provider.',
  email_bounced: 'Reach out to customer and select a new FFL provider.',
  license_acquisition_failed:
    'Reach out to customer and select a new FFL provider.'
};
export const transferType = {
  in_bound: 'Inbound',
  out_bound: 'Outbound',
}

export const storeTypeFilters = {
  true: "true",
  false: "false",
}

export const sellerLicenseKeyFilter = {
  linked_transfer: "Exclude Linked Transfers"
}

export const transferTypeFilter = {
  ffl: "FFL",
  non_ffl: "Non FFL"
}

export const dealerLogActionTypeFilter = {
  system: "System",
  called: "Called",
  emailed: "Emailed",
  "profile edit": "Profile Edit",
  other: "Other"
}

// export const linkedTransferFilter = {
//   all: "All Transfers",
//   linked_only: "Linked Transfers Only",
//   exclude_linked: "Exclude Linked Transfers"
// }

export const LINKED_TRANSFERS = "LINKED TRANSFERS";

export const adminStoreTypeFilters = {
  live: "Show Only Live Stores",
}
export const firearmType = {
  NFASuppressor: 'NFA Item',
  Pistol: 'Handgun (Pistol or Revolver)',
  Rifle: 'Long Gun (Rifle or Shotgun)',
  SBR: 'Other Firearms (Frame, Receiver, etc)',
  MultipleFirearmTypes: 'Multiple Firearm Types'
}
export const inboundMacrostatus = {
  inbound_transfer_pending: 'Pending Outbound Confirmation',
  inbound_transfer_awaiting_item: 'Awaiting Item',
  inbound_transfer_item_received: 'Item Received',
  inbound_transfer_complete: 'Inbound Transfer Complete',

};

export const inboundMicrostatus = {
  item_recieved: 'Email Sent to consumer offering T&C',
  consumer_agree_term_and_conditions: 'Consumer agrees to T&C',
  consumer_picked_up: 'Item Picked up',
};
export const transferMicrostatusFilters = {
  waiting_for_admin: 'Waiting for email',
  email_delivered: 'Email Delivered',
  license_acquisition_failed: 'License Acquisition Failed',
  license_validation_failed: 'License Validation Failed',
  license_validated: 'License Validated',
  upload_license: 'Upload license',
};


export const transferMicrostatus = {
  email_opened: 'Email Opened',
  email_clicked: 'Email Clicked',
  ez_check: 'EzCheck',
  ocr_checks: 'OCR & Sanity Checks',
  uploaded_sot_tax_stamp: 'Uploaded SOT Tax Stamp',
  sot_tax_stamp_validated: 'SOT Tax Stamp Validated',
  waiting_license_validation: 'SOT Tax Stamp Validated',
  sot_tax_stamp_validation_failed: 'SOT Tax Stamp Validation Failed',
  uploaded_loa_certificate: "Uploaded LOA Certificate",
  loa_certificate_validated: "LOA Certificate Validated",
  loa_certificate_validation_failed: "LOA Certificate Validation Failed",
  dealer_unresponsive: 'Dealer unresponsive',
  email_bounced: 'Valid email not found (Email delivery failed)',
  receiving_ffl_click: `Receiving FFL clicks "take action" link`,
  reject_terms_and_condition: "T&C Rejected",
  accept_terms_and_condition: "T&C Accepted",
  waiting_for_terms_and_condition: "Waiting for T&C Agreement",
  dealer_selected: "Dealer changed",
  resent_email: "Resent email",
  customer_selected: "Email sent to customer for dealer selection",
  email_reminder_sent: "Waiting for dealer action on final reminder",
  ...transferMicrostatusFilters,
};

export const pastTenseStatus: any = {
  waiting_for_email: 'Email acquired',
  upload_license: 'License uploaded',
  ocr_checks: 'OCR & Sanity Checks Passed',
  ez_check: 'EzCheck passed',
  waiting_license_validation: 'Document Processing',
  transfer_resume_attempted: 'Transfer resume attempted',
};

export const pastTenseFailedStatus: any = {
  waiting_license_validation: 'Document Processing Failed',
  sot_tax_stamp_validated: 'License/SOT Validation Failed',
  loa_certificate_validated: 'License Validation Failed'
};

export const transferErrorMicrostatus = [
  'opted_out',
  'email_not_found',
  'email_bounced',
  'license_acquisition_failed',
  'license_validation_failed',
  'dealer_unresponsive',
  'reject_terms_and_condition',
  'sot_tax_stamp_validation_failed',
  'loa_certificate_validation_failed'
];

export const transfer48HrsSuggestion =
  'Dealer did not responded within 48 hrs. Contact the dealer to remind them of the transfer or request buyer to choose another dealer.';

export const transferStepStatus = {
  failed: 'failed',
  in_progress: 'in_progress',
  pending: 'pending',
  success: 'success'
};

export const DOWNLOAD_MASTER_PROOF_TEXT = 'Download Sender FFL Master Proof';

export const TransferDetailsInitialState = {
  TransferDetails: {
    message: {
      usedEmail: '',
      lastMessageStatus: null,
      lastMessageSent: null,
      transfer_proof_link: null
    },
    certificateWorkflowStatus: {
      step: null,
      status: '',
      time: null
    },
    optChoice: {
      value: '',
      time: null
    },
    products: null,
    status: '',
    buyerName: null,
    orderId: '',
    sku: '',
    buyer: {
      street: null,
      city: null,
      state: null,
      zipCode: null,
      name: '',
      phone: '',
      email: ''
    },
    transfer_proof_link: '',
    transfer_proof_path: '',
    transferSellerPacket:'',
    notes: '',
    orderDate: '',
    storeURL: null,
    modelType: '',
    shippingAddress: null,
    transferId: "",
    agentName: "",
    agentEmail: "",
    isArchive: undefined,
    transferType: null,
    transferCode: "",
    microStatus: null,
    numberOfDealerAssgined: 0,
    createdAt: '',
    outboundTransferCompletionTimestamp: '',
    version: 2,
    requestId: '',
  },
  fflMasterDetails: {
    licenseId: '',
    contactName: null,
    businessType: '',
    email: [],
    contactNumber: [],
    businessName: null
  },
  SellerDetails: {
    licenseId: ""
  }
};

export const BLACKLISTED_TEXT = "Blacklisted";
export const REMOVE_DEALER_FROM_BLACKLIST_CONFIRMATION = "The dealer will be removed from blacklist. Do you want to proceed?";
export const AGENT = "AGENT";
export const FIREARM_TYPE = "FIREARM TYPE";
export const SEARCH_SELLER = "SELLER SEARCH";
export const TRANSFER = "TRANSFER TYPE"
export const ARCHIVE = 'ARCHIVED TRANSFERS';
export const OUTBOUND_STATUS = "OUTBOUND STATUS";
export const OUTBOUND_SUB_STATUS = "OUTBOUND SUB STATUS";
export const INBOUND_STATUS = "INBOUND STATUS";
export const INBOUND_SUB_STATUS = "INBOUND SUB STATUS";
export const TRANSFER_TYPE = "TRANSFER TYPE";
export const TRANSFER_DATE = "TRANSFER DATE";
export const STORE_NAME = "STORE NAME";
export const SOURCE_DESCRIPTION = "SOURCE";
export const DELETE_USER_CONFIRMATION = "Are you sure you want to delete this user? This action cannot be undone.";
export const BUSINESS_NAME = "Receiving FFL";
export const EDIT_PROFILE = "Edit Profile";
export const CANCEL_LABEL = "Cancel";
export const CANCEL_TEXT = "Reset";
export const SAVE_TEXT = "Save";
export const EDIT_TEXT = "Edit";
export const STORE_TYPE_LABEL = "Store Type";
export const PENDING_TRANSFER_NAME = "EXCLUDE TRANSFERS";
export const ECOMMERCE_STATUS = "E-COMMERCE STATUS";
export const STORE_ADMIN_ROLE_ACTIONS = {
  AGENT: "Store Agent",
  STORE_ADMIN: "Store Admin"
}
export const USER_ACCOUNT_STATUS_ACTIONS = {
  enabled: "Enabled",
  disabled: "Disabled"
}

export const USER_ROLES = {
  agent: "AGENT",
  admin: "STORE_ADMIN",
  globalAdmin: "GLOBAL_ADMIN"
}

export const BLACKLIST_ERROR = 'Cannot initiate transfer as dealer is blacklisted'
export const ARCHIVE_TEXT = "Archive";
export const UN_ARCHIVE_TEXT = "Unarchive";
export const UN_ARCHIVE_TRANSFER_TEXT = "Unarchive this transfer";
export const ARCHIVE_TRANSFER_TEXT = "Archive this transfer";

export const SOURCE_OF_LICENSE: any = {
  upload_ui: 'Dealer',
  email: 'Email',
  backend: 'Backend',
  ffl360: "FFL 360",
  email_campaign: "Email Campaign",
  myffl: "MyFFL"
}
export const LICENSE_NUMBER_NOT_FOUND = "License number not found.";
export const INVALID_LICENSE_NUMBER = "Invalid license number.";
export const ACTION_FAILED_ERROR = "Action failed, try again later or contact support for assistance.";
export const ARCHIVE_HEADER_NAME = "Archive Date";
export const UN_ARCHIVED = "unarchived";
export const ARCHIVED = "archived";
export const TRANSFER_ACTION_SUCCESSFULL = "Great! Your transfer has been successfully {{ACTION}}.";
export const VIEW_THE_PAGE = "View the {{PAGE}}";
export const TRANSFER_QUEUE = "Transfer Queue";

export const MAX_COMPANY_LOGO_FILE_SIZE_MB = 2;
export const ALLOWED_COMPANY_LOGO_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif'];
export const UPLOAD_FAILED_ERROR = "Failed to upload logo!";
export const UPDATED_STORE_PROFILE = "Store profile updated successfully.";
export const UPDATED_DEALER_ACTION_TIMEOUT = "Dealer action timeout updated successfully.";
export const TRY_AGAIN = "Something went wrong, Please try again!";
export const TRY_AGAIN_OR_CONTACT_SUPPORT = "Something went wrong, Please try again or contact MasterFFL support for assistance.";
//
export const FFL_RECEIVER_DEALER_LABEL = "Receiving FFL";
export const FFL_SELLER_DEALER_LABEL = "Seller FFL";
export const FFL_STORE_CONFIGURATION = "FFL Store Configuration";
export const FFL_REMOVE_ENCRYPTION_KEY = "This will remove the existing encryption key. Do you want to proceed?";
export const FFL_CREATE_ENCRYPTION_KEY = "This will create a new encryption key. Do you want to proceed?";
export const FFL_RE_CREATE_ENCRYPTION_KEY = "This will remove the existing encryption key and generate another encryption key. Do you want to proceed?";
export const REMOVE_TEXT = "Remove";
export const REGENERATE_TEXT = "Regenerate";
export const GENERATE_TEXT = "Generate";
export const FFL_ENCRYPTION_KEY = "FFL encryption key";
export const NO_KEY_GENERATED = "No key generated"
export const EMAIL_SEARCHING_LABEL = "Email Searching";
export const FILTER_SAVE_ACTION_SUCCESSFUL = "Filter has been Saved."
export const FILTER_CLEARED_ACTION = "Filters Removed Successfully."
export const UPDATE_PERMISSION_ACTION_SUCCESSFUL = "Permissions has been Saved."

export const typeList: any = {
  '01 - Firearm Dealer/Gunsmith': '01',
  '02 - Pawnbroker': '02',
  // '03 - Collector of Curios and Relics': '03',
  '06 - Manufacture of Ammunition other than Destructive Devices': '06',
  '07 - Manufacturer of Firearms': '07',
  '08 - Importer of Firearms': '08',
  '09 - Dealer of Destructive Devices': '09',
  '10 - Manufacturer of Destructive Devices': '10',
  '11 - Importer of Destructive Devices': '11',
};

export const CREATE_STORE_LABELS = {
  LICENSE_ID_LABEL: 'License ID*:',
  LICENSE_NUMBER_HELPER_TEXT: 'Enter FFL License Number',
  LICENSE_TYPE_LABEL: 'License Type',
  STORE_DOMAIN_LABEL: 'Store Domain',
  BUSINESS_NAME_LABEL: "Business Name:",
  CONTACT_NAME_LABEL: 'Contact Name:',
  MAILING_ADDRESS_LABEL: 'Mailing Address:',
  SENDER_EMAIL_LABEL: 'Sender Email:',
  EMAIL_DOMAIN_LABEL: '@masterffl.com',
  ONBOARD_STORE_LABEL: 'Onboard Store',
  IS_EXTERNAL_LABEL: 'Is Live Store',
  CFD_LABEL: 'CFD Required',
  IS_MULTITENANT_LABEL: 'Is Multi-Tenant',
  CUSTOM_REASSIGNMENT_URL_MULTI_VENDOR: 'Redirect Reassignment URL',
  REASSIGNMENT_URL_LINK_TEXT: 'Redirect URL',
  REASSIGNMENT_REDIRECT_URL_INFO_LABEL: 'Enable this to redirect reassignment requests to a custom URL for multi-tenant stores'
};

export const ExportFFLLiveUserEnum = {
  pending: 'pending',
  completed: 'completed'
};

export const CREATE_STORE_EMAIL_ERROR = 'This sender email already used try with another email.'
export const CREATE_STORE_DOMAIN_ERROR = 'Store domain is already used try with another domain.'
export const CREATE_STORE_LICENSE_ID_ERROR = 'This license is already used.'
export const FFL_SELECT_CONFIGURATION = "FFL Select Configuration";

export const INBOUND_TRANSFER_STATUS_CORRESPONDING_ACTION = {
  inbound_transfer_awaiting_item: "Item Received",
  inbound_transfer_item_received: "Consumer Picked Up"
}
export const INBOUND_TRANSFER_ACTION = {
  inbound_transfer_awaiting_item: "item_recieved",
  inbound_transfer_item_received: "consumer_picked_up"
}

export const INBOUND_TRANSFER_API_STATUES_RESPONSE = {
  inbound_transfer_pending: "inbound_transfer_pending",
  inbound_transfer_awaiting_item: "inbound_transfer_awaiting_item",
  inbound_transfer_item_received: "inbound_transfer_item_received",
  inbound_transfer_complete: "inbound_transfer_complete",
  inbound_transfer_failed: "inbound_transfer_failed"
}


export const TRANSFER_DETAILS = {
  TRANSFER_DETAIL_LABEL: "Transfer Detail",
  TRANSFER_CODE: "Transfer Code",
  SELLER_FFL_DETAILS: "Seller FFL Dealer Details",
  BUSINESS_NAME_LABEL: "Business Name",
  CONTACT_NAME: "Contact Name",
  LICENSE_NUMBER: "License Number",
  COMPLIANCE_AGENT_NAME: "Compliance Agent Name",
  PHONE_LABEL: "Phone Number",
  COMPLIANCE_AGENT_EMAIL: "Compliance Agent Email",
  MAILING_ADDRESS_LABEL: 'Mailing Address',
  LICENSE_EXPIRY: "License Expiry Date",
  RECIVEING_FFL_DEALER: "Receiving FFL Dealer Details",
  RECIEVING_BUSINESS_NAME: "Receiving Business Name",
  BUSINESS_CONTACT_NUMBER: "Business Contact Number",
  EMAIL: "Email",
  LICENSE_EXPIRY_DATE: "License Expiry Date",
  DEALER_OPTED_IN: "Dealer opted in for this transfer on",
  LICENSE_ACQUIRED_DATE: "License Acquired Date",
  LAST_EZ_CHECK: "Last EZ Check Date & Time",
  EZ_CHECK: "EZ Check (Pass/Fail)",
  ORDER_DETAILS: "Order Details",
  NAME: "Name",
  ORDER_NUMBER: "Order Number",
  MODEL_TYPE: "Model & Type",
  EMAIL_ADDRESS: "Email Address",
  ORDER_DATE: "Order Date",
  FIREARM_TYPE: "Firearm Type",
  SHIPPING_ADDRESS: "Preferred Shipping Address",
  TRANSFER_STATUS: "Transfer Status",
  ARCHIVED: 'Archived',
  DOWNLOAD_SENDER_MASTER_PROOF: "Sender FFL Master Proof",
  DOWNLOAD_RECIEVER_MASTER_PROOF: "Sender FFL Master Proof",
  GENERATE_MASTER_PROOF: "Refresh Master Proof",
  SELLER_FFL_DETAILS_TOOLTIP: "Go to seller dealer profile",
  RECEIVING_FFL_DETAILS_TOOLTIP: "Go to receiving dealer profile",
  RESEND_INITIATE_EMAIL_TEXT: "Re-send the initiation email",
}

export const ADD_THIS_EMAIL_ANYWAY = "I want to add this email anyway."
export const IMPERSONATING_INFO = "You are impersonating";
export const STOP_IMPERSONATING = "Stop Impersonating";
export const STORE_ACCOUNT = "store account";
export const SELECT_FIELD_DATE = "Please select {{field}} date";
export const INVALID_RANGE = "Invalid range";
export const DEALER_ACTION_TIMOUT_TOOL_TIP_CONTENT = "Transfer will move to a Failed Status after waiting on the dealer action for these many days. Set it to 0 if you don’t want to move it to failed status automatically.";

export const DEALER_UNRESPONSIVE_INITIATION_TOOL_TIP_CONTENT = "The timer starts when the system sends a take action email to the dealer regarding the transfer. If the dealer does not respond, the process will proceed to the last-chance email step."
export const DEALER_UNRESPONSIVE_CONFIRMATION_TOOL_TIP_CONTENT = "The timer starts when the dealer was automatically opted in but has not processed any orders prior to this first-time order. The process will complete if no response is received from the dealer."
export const DEALER_SMS_EMAIL_UPDATE_TIMEOUT_TOOL_TIP_CONTENT = "The timer starts when an SMS is sent to the dealer requesting an email address update or opt-out. If no response is received from the dealer, the process proceeds to manual email search by the FFL Support team"
export const FFL_SUPPORT_EMAIL_UPDATE_TIMEOUT_TOOL_TIP_CONTENT = "The timer will begin once the dealer's SMS response time expires. If the FFL support agent does not respond or records the email address as 'not found,' the process will be escalated to an agent for further action"
export const STORE_AGENT_EMAIL_UPDATE_TIMEOUT_TOOL_TIP_CONTENT = "The timer will start when the FFL Support agent’s response time expires or an 'Email Address Not Found' action is recorded. The process will then send an email to the customer, requesting them to update the email address or change the dealer."
export const CUSTOMER_ACTION_TIMEOUT_TOOL_TIP_CONTENT = "The timer will start when the system sends the take action email to the customer. The process will be placed on 'HOLD' if the customer fails to respond before the timer expires"
export const DEALER_LAST_CHANCE_ACTION_TIMEOUT_TOOL_TIP_CONTENT = "The timer starts when the system sends a last-chance notification email to the dealer. If the dealer does not respond, the process will proceed to send the Assign New Dealer action email to the customer."
export const DEALER_DOCUMENTS_PROCESSING_TIMEOUT_TOOL_TIP_CONTENT = "The timer starts when the dealer initiates the document upload process by clicking the 'Upload' action. This timer specifically impacts the document uploading and validation process. If the dealer fails to complete the upload and validation within the given time, the process will proceed to the assign new email to the customer step."
export const DEALER_DOCUMENTS_REUPLOAD_TIMEOUT_TOOL_TIP_CONTENT = "The timer starts when the system sends an email notifying the dealer of the rejected document. If the dealer fails to complete the document upload and validation within the given time, the process will proceed to the dealer change action email to the customer step."
export const CUSTOMER_REASSIGNMENT_EMAIL_REMINDER_TIMEOUT_TOOL_TIP_CONTENT = "The timer starts when the customer reassignment email is sent. If the customer does not take any action within the configured time, a reminder reassignment email will be sent to the customer.";


export const NOTES_TEXT = "Notes";
export const HISTORY_TEXT = "History";
export const FFL_LICENSE_TEXT = "FFL License";
export const STATUS = "Process Step";
export const SUB_STATUS = "Current Status";
export const E_COMMERCE_PLATFORM = [
  {
    name: "Magento",
    value: eCommercePlatform.MAGENTO
  },
  {
    name: "Big Commerce",
    value: eCommercePlatform.BIG_COMMERCE
  },
  {
    name: "Woo Commerce",
    value: eCommercePlatform.WOO_COMMERCE
  },
]
export const INBOUND_HISTORY_TEXT = "Inbound History";
export const OUTBOUND_HISTORY_TEXT = "Outbound History";
export const REASSIGN_FAILED_ERROR = "Cannot assign same dealer again.";
export const ASSIGN_NEW_DEALER_TEXT = "Assign New Dealer";
export const DEALER_ALREADY_ASSIGNED_ERROR = "Dealer is already assigned.";

export const stepMapping: any = {
  '1': 'Unknown error',
  '2': 'Unsupported file format',
  '10': 'OCR Failed',
  '11': 'OCR Failed',
  '12': 'License number or expiry date not recognized',
  '13': 'Duplicate certificate uploaded',
  '14': 'Different document uploaded',
  '15': "License already pending for admin approval",
  '16': "Invalid Document",
  '30': 'EZ Check failed',
  '31': 'EZ Check failed',
  '32': 'EZ Check failed',
  '33': 'EZ Check failed',
  '50': 'License validation failed',
  '52': 'Dealer id not matched for transfer',
  '53': 'License number or expiry date not recognized',
  '54': 'License Expired',
  '55': 'Address review required',
  '56': 'Names mismatch',
  '57': 'Signature not detected',
  '58': 'Poor document quality',
  '59': 'Missing PositionTitle / PrintedName / PrintedDate',
  '71': 'Unknown error',
  '100': 'Deleted From Profile',
  "101": "Invalidated certificates after addresses changed through ATF",
  "102": "Invalidated certificates after name changed through ATF"
};

export const sotFailedSteps: any = {
  '13': 'Duplicate certificate uploaded',
  '54': 'SOT Expired',
  '58': 'Poor document quality',
};

export enum TransferDateFieldEnum {
  dateFrom = 'dateFrom',
  dateTo = 'dateTo'
}

export const reviewFiltersHeadings = {
  status: "STATUS",
  faildSteps: "FAILURE REASON",
  store: "STORE",
  createdAt: "CREATED DATE",
  source: "SOURCE",
  storeType: "STORE TYPE",
  uploadedAt: "UPLOADED ON",
  manualReview: "MANUAL REVIEW",
  additional: "Additional Filters"
}

export const reviewFilters = {
  status: [
    {
      label: "Pending",
      value: "pending"
    },
    {
      label: "Approved",
      value: "approved"
    },
    {
      label: "Rejected",
      value: "rejected"
    },
    {
      label: "Reviewed",
      value: "reviewed"
    },
  ],
  faildSteps: [
    {
      label: "Unknown error",
      value: "1"
    },
    {
      label: "Unsupported file format",
      value: "2"
    },
    {
      label: "OCR Failed",
      value: "10"
    },
    {
      label: "License number or expiry date not recognized",
      value: "12"
    },
    {
      label: "Duplicate certificate uploaded",
      value: "13"
    },
    {
      label: "Different certificate uploaded",
      value: "14"
    },
    {
      label: "License already pending for admin approval",
      value: "15"
    },
    {
      label: "Invalid Document",
      value: "16"
    },
    {
      label: "EZ Check failed",
      value: "30"
    },
    // {
    //   label: "License validation failed",
    //   value: "50"
    // },
    {
      label: "Dealer id not matched for transfer",
      value: "52"
    },
    {
      label: "License Expired",
      value: "54"
    },
    {
      label: "Deleted From Profile",
      value: "100"
    },
    {
      label: "Address Review Required",
      value: "55"
    },
    {
      label: "Invalidated certificates after addresses changed through ATF",
      value: "101"
    },
    {
      label: "Names mismatch",
      value: "56"
    },
    {
      label: "Invalidated certificates after name changed through ATF",
      value: "102"
    },
    {
      label: "Signature not detected",
      value: "57"
    },
    {
      label: "Poor document quality",
      value: "58"
    },
    {
      label: "Missing PositionTitle / PrintedName / PrintedDate",
      value: "59"
    },
  ],
  source: [
    {
      label: "Dealer",
      value: "upload_ui"
    },
    {
      label: "Email",
      value: "email"
    },
    {
      label: "Backend",
      value: "backend"
    },
    {
      label: "FFL 360",
      value: "ffl360"
    },
    {
      label: "Email Campaign",
      value: "email_campaign"
    }
  ],
  storeType: [
    {
      label: "Show Only Live Records",
      value: "true",
    },
  ],
  sotFailedSteps: [
    {
      label: "Duplicate certificate uploaded",
      value: "13"
    },
    {
      label: "SOT Expired",
      value: "54"
    },
    {
      label: "Already exist in approval queue",
      value: "15"
    },
    {
      label: "Unsupported file format",
      value: "2"
    },
    {
      label: "Poor document quality",
      value: "58"
    },
  ],
  loaFailedSteps: [
    {
      label: "Duplicate certificate uploaded",
      value: "13"
    },
    {
      label: "LOA Expired",
      value: "54"
    },
    {
      label: "Already exist in approval queue",
      value: "15"
    },
    {
      label: "Unsupported file format",
      value: "2"
    },
    {
      label: "Poor document quality",
      value: "58"
    },
  ],
  isManuallyRequested:[
    {
      label: "Show Only Manual Requested",
      value: 'isManuallyRequested'
    },
  ],
  additional: [
    {
      label: "Show all Failures",
      value: true
    }
  ]
};

export const reviewChipValues = {
  '1': 'Unknown error',
  '2': 'Unsupported file format',
  '10': 'OCR Failed',
  '12': 'License number or expiry date not recognized',
  '13': 'Duplicate certificate uploaded',
  '14': 'Different certificate uploaded',
  '15': "License already pending for admin approval",
  '16': "Invalid Document",
  '30': 'EZ Check failed',
  // '50': 'License validation failed',
  '52': 'Dealer id not matched for transfer',
  '54': 'License Expired',
  '71': 'Unknown error',
  '100': 'Deleted From Profile',
  '55': 'Address review required',
  '56': 'Names mismatch',
  '57': 'Signature not detected',
  '58': 'Poor document quality',
  '59': 'Missing PositionTitle / PrintedName / PrintedDate',
  'upload_ui': 'Dealer',
  'email': 'Email',
  'backend': 'Backend',
  'ffl360': 'FFL 360',
  'true': 'Show Only Live Records',
  'false': 'Testing',
  'email_campaign': 'Email Campaign',
  'testing': 'Testing',
  'live': 'Show Only Live Stores',
  'isManuallyRequested': 'Show Only Manual Requested',
  "101": "Invalidated certificates after addresses changed through ATF",
  "102": "Invalidated certificates after name changed through ATF"
}

/** Core rejection labels (order preserved for dropdowns via Object.entries). */
const reviewRejectedReasonsCore = {
  expired_document: "License Expired",
  redundant_copy: "Duplicate Certificate Uploaded",
  inadequate_quality: "Inadequate quality",
  invalid_document: "Invalid document",
}

/** Rejection dropdown labels shared by FFL, SOT, and LOA; "Others" last. */
export const reviewRejectedReasonsSot = {
  ...reviewRejectedReasonsCore,
  others: "Others",
}

/** FFL + LOA: core + ATF/signature reasons; "Others" last. */
export const reviewRejectedReasonsFflLoa = {
  ...reviewRejectedReasonsCore,
  atf_address_mismatch: "ATF address mismatch",
  names_mismatch: "Names mismatch",
  missing_position_title_printed_name_date: "Missing PositionTitle / PrintedName / PrintedDate",
  no_signature: "No signature",
  others: "Others",
}

/** @deprecated Prefer reviewRejectedReasonsFflLoa (explicit) or reviewRejectedReasonsSot */
export const reviewRejectedReasons = reviewRejectedReasonsFflLoa

const LEGACY_REJECTED_REASON_LABELS: Record<string, string> = {
  "Expired document": reviewRejectedReasonsSot.expired_document,
  "Redundant copy": reviewRejectedReasonsSot.redundant_copy,
}

/** Maps API/stored rejection strings to current dropdown labels (e.g. after copy updates). */
export function normalizeRejectedReasonFromApi(reason: string | null | undefined): string {
  if (reason == null || reason === "") return ""
  return LEGACY_REJECTED_REASON_LABELS[reason] ?? reason
}
export const transferMacrostatusV2: any = {
  all: 'All',
  tranfer_pending: 'Pending',
  transfer_initiated: 'Transfer Initiated',
  initiation_email_sent: 'Email Processing',
  waiting_dealer_action: 'Dealer Action',
  waiting_license_validation: 'Document Processing',
  outbound_transfer_complete: 'Transfer Completion'
}
export const transferMacroSubStatusV2: any = {
  tranfer_pending: {},
  transfer_initiated: {
    queue_status_on_hold: "On Hold",
    // queue_status_dealer_changed: "Dealer Changed",
  },
  initiation_email_sent: {
    queue_status_sms_sent_to_dealer: "SMS to Dealer",
    queue_status_email_manually_searching: "Email Discovery",
    // queue_status_email_updated: "Email Updated",
    queue_status_agent_action_for_transfer: "Compliance Agent Needs to Find email",
    queue_status_email_available: "Email Available",
    queue_status_dealer_change_email_to_customer: "Action Email to Customer",
    queue_status_email_unreachable: "Email Unreachable"
    // queue_status_action_email_to_dealer: "Action Email to Dealer",
    // queue_status_notification_email_to_dealer: "Notification Email to Dealer",
  },
  waiting_dealer_action: {
    queue_status_action_pending: "Action - Pending",
    // queue_status_optin_auto: "Optin - Auto",
    // queue_status_optin_dealer: "Optin - Dealer",
    // queue_status_optout_dealer: "Optout - Dealer",
    queue_status_first_time_confirmation_delay: "First Time Confirmation Delay",
    queue_status_dealer_change_email_to_customer: "Dealer Change Email to Customer",
    // queue_status_optout_time_expired: "Optout - Time Expired",
  },
  waiting_license_validation: {
    queue_status_required_document_pending: "Required Document - Pending",
    // queue_status_required_document_available: "Required Document - Available",
    queue_status_dealer_change_email_to_customer: "Dealer Change Email to Customer",
    queue_status_ez_check_failed: "EZ check failed",
    // queue_status_manual_license_review :'Required Document - Approval'
  },
  outbound_transfer_complete: {
    queue_status_ready_for_outbound_processing: 'Ready for Outbound Processing',
  }
};


export const transferQueueSubStatusV2 = {
  queue_status_on_hold: "On Hold",
  queue_status_dealer_changed: "Dealer Changed",
  queue_status_sms_sent_to_dealer: "SMS to Dealer",
  queue_status_email_manually_searching: "Email Discovery",
  queue_status_email_updated: "Email Updated",
  queue_status_agent_action_for_transfer: "Compliance Agent Needs to Find email",
  queue_status_email_available: "Email Available",
  queue_status_email_unreachable: "Email Unreachable",
  queue_status_action_email_to_customer: "Action Email to Customer",
  queue_status_dealer_change_email_to_customer: "Dealer Change Email to Customer",
  queue_status_first_time_confirmation_delay: "First Time Confirmation Delay",
  queue_status_action_email_to_dealer: "Action Email to Dealer",
  queue_status_notification_email_to_dealer: "Notification Email to Dealer",
  queue_status_action_pending: "Action - Pending",
  queue_status_optin_auto: "Optin - Auto",
  queue_status_optin_dealer: "Optin - Dealer",
  queue_status_optout_dealer: "Optout - Dealer",
  queue_status_optout_time_expired: "Optout - Time Expired",
  queue_status_required_document_pending: "Required Document - Pending",
  queue_status_required_document_available: "Required Document - Available",
  queue_status_ez_check_failed: "EZ check failed",
  queue_status_ready_for_outbound_processing: 'Ready for Outbound Processing',
  // queue_status_manual_license_review :'Required Document - Approval',
  ...transferMicrostatus,
}

export const transferDetailsMicroStatus: any = {
  ...transferMicrostatus,
  completed: 'Completed',
  in_hold: 'On Hold',
  in_progress: 'In Progress',
  transfer_initiated: 'Initiated',
  customer_selected: "Dealer changed by customer",
  email_available: 'Email available in dealer profile',
  waiting_for_admin: 'Master FFL Support searching for email',
  email_acquired: 'Email acquired',
  email_not_found: 'Unable to find email',
  waiting_for_customer_action: 'Waiting for customer action',
  email_unreachable: "Email Unreachable",
  waiting_for_agent_action: 'Waiting for compliance agent action',
  dealer_action_pending: 'Waiting for dealer to take action on email ',
  accepted_transfer: 'Action - Auto',
  first_time_confirmation_delay: "First time confirmation delay",
  opted_out: 'Action - OPT OUT',
  required_documents_pending: 'Required documents - pending',
  dealer_documents_pending: "'NAME' - Acquisition/Validation in progress",
  document_validated: "'NAME' - OCR / Sanity Check",
  manual_license_review: "'NAME' manually approved",
  manual_review_pending: "'NAME' manually review pending",
  ready_for_outbound_processing: "Ready for outbound processing",
  sms_sent_to_dealer: "Waiting for dealer Action for SMS",
  transfer_sms_send_to_dealer_timeout: "SMS for email acquisition scheduled",
  required_documents_available: 'All Required documents - available',
  document_available: 'Document Available',
  document_uploaded: 'Document Uploaded',
  skip_step_acquired: 'Step manually skipped',
  transfer_resume_attempted: 'Transfer resume attempted'
}

export const EnumTransferMessageType: any = {
  resend: 'Take action email to dealer by user',
  reassignment: 'Take action email to customer',
  initiation: 'Take action email to dealer',
  first_time_confirmation: 'First time transfer confirmation email to dealer',
  reminder: 'Final reminder email to dealer',
  completion: 'Transfer confirmation email to dealer',
  manually_rejection: 'Manual review rejected notification email to the dealer',
  customer_reminder: 'Final reminder email to customer',
  acquire_seller_documents: 'Take action email to seller',
  transfer_initiated_buyer_seller: 'Transfer initiated notification to buyer/seller',
  transfer_initiated_buyer: 'Transfer initiated notification to buyer',
  transfer_initiated_seller: 'Transfer initiated notification to seller',
  transfer_complete_buyer_seller: 'Transfer complete notification to buyer/seller',
  transfer_complete_receiving_dealer: 'Transfer complete notification to receiving dealer',
  transfer_canceled_prior_dealer: 'Transfer canceled notification to prior dealer',
  dealer_reassignment_buyer_seller: 'Dealer reassignment notification to buyer/seller',
  dealer_reassignment_seller: "Dealer reassignment notification to seller",
  dealer_reassignment_buyer: 'Dealer reassignment notification to buyer',
  transfer_stalled_seller_help: 'Transfer stalled notification to seller',
  transfer_complete_seller: 'Transfer complete notification to seller',
  transfer_complete_buyer: 'Transfer complete notification to buyer'
}

export const TRANSFER_DETAILS_V2_CONSTANTS = {
  ORDER_ID: "Order ID",
  RE_SEND_INITIATION_EMAIL_LABEL: 'Re-send the initiation email',
  TRANSFER_INITIATION_LABEL: 'Transfer Initiation',
  CUSTOMER_LABEL: 'Customer',
  CURRENT_FFL_DEALER_LABEL: 'Current FFL Dealer',
  SELLER_LABEL: 'Seller',
  STORE_INITIATING_TRANSFER_LABEL: 'Store Initiating This Transfer',
  VIEW_PREVIOUS_DEALERS_LABEL: 'View previous dealers',
  PREVIOUS_DEALERS_LABEL: 'Previous Dealers',
  FIRST_ORDER_LABEL: 'Is First Order',
  TRANSFER_COUNT: 'Transfer Count',
  VIEW_HISTORY_TEXT: 'Click on “View” to see history of selected dealer',
  FFL_MASTER_TRANSFER_PROOF: 'FFL Master Transfer Proof',
  REFRESH_MASTER_TRANSFER_PROOF: 'Refresh Master Transfer Proof',
  RECEIVING_DEALER_DOCUMENTS_LABEL:'Receiving Dealer’s Documents'
}

export const EXCLUDE_TRANSFER_FILTERS = {
  tranfer_pending: 'Pending',
  outbound_transfer_complete: 'Completed',
  queue_status_first_time_confirmation_delay: 'First Time Confirmation Delay'
}

export const defaultConfig: any = {
  transfer: [
    "list",
    "archive",
    "filters"
  ],
  dealerSearch: [
    "filters",
    "map",
    "radius",
    "sortBy",
    "IsWildCardSearchAllowed"
  ],
  profileEdit: {
    editOthers: true, 
    editSelf: false 
  },
  admin: [
    "users",
    "selectConfig",
    "blacklisted",
    "preferred",
    "stocking",
    "parameters",
    "preferedReport",
    "termsConditions"
  ]
}


export const tabsLabels: any = {
  transfer: 'Transfer Queue',
  dealerSearch: 'Search',
  profileEdit: "Edit Profile",
  editOthers: "Allow Editing", 
  editSelf: "Allow Editing Self Profile",
  admin: 'Admin',
  users: 'Users',
  selectConfig: 'FFL Select',
  blacklisted: 'Blacklisted',
  preferred: 'Preferred',
  stocking: 'Stocking',
  parameters: 'Parameters',
  preferedReport: 'Preferred Dealer Report',
  termsConditions: 'Terms & Conditions',
  ecommerceStatusMapping: 'Admin',
  IsWildCardSearchAllowed: "Wildcard(*) Search"
}

export const adminTabs = {
  storeProfile:{
    id: '0',
    tab: 'manage-dealer-profile'
  },
  users: {
    id: '1',
    tab: 'manage-users'
  },
  selectConfig: {
    id: '2',
    tab: 'fflselect'
  },
  blacklisted: {
    id: '3',
    tab: 'blacklist-dealers'
  },
  preferred: {
    id: '4',
    tab: 'upload-preferred-dealers'
  },
  stocking: {
    id: '5',
    tab: 'upload-stocking-dealers'
  },
  parameters: {
    id: '6',
    tab: 'manage-parameters'
  },
  preferedReport: {
    id: '7',
    tab: 'preferred-dealers-report'
  },
  termsConditions: {
    id: '8',
    tab: 'manage-terms-and-conditions'
  },
  ecommerceStatusMapping: {
    id: '9',
    tab: 'admin'
  },
  fflStripeConfiguration: {
    id: '10',
    tab: 'ffl-stripe-configuration'
  },
  customWebhook: {
    id: '11',
    tab: 'enriched-webhook'
  },
};
export const TRANSFER_UPLOAD_V2 = {
  DOCUMENT_VALIDATION_INSTR_DESC: 'Your document will be optimized and scanned using OCR. The system will extract and validate the necessary information to ensure accuracy and completeness. This process may take a few moments, and you will be notified once it is complete.',
  DOCUMENT_VALIDATION_INSTR_TITLE: 'What is going on now?',
  SUBMITTED_REVIEW_TITLE:'The Document is Submitted for Review',
  SUBMITTED_REVIEW_DESC:'Your document will be validated manually by the system administrator. This process may take up to two business days to complete.',
  SUBMITTED_FOR_REVIEW:'Submitted for Review',
  UPLOAD_NEW_FILE_BTN: 'Upload New File',
  REQUEST_FOR_MANNUAL_REVIEW_BTN:'Request Manual Review',
  DOCUMENT_VALIDATION_NEW_TITLE:'Upload a new document and try again.',
  DOCUMENT_VALIDATION_NEW_DESC:'If you believe the document is valid, you can submit it for manual review by an admin.',
  DOCUMENT_VALIDATION_FAILED_DESC:'The document could not be validated automatically. You have two options:',
}

export const transferTabs = {
    outbound: 'Outbound',
    inbound: 'Inbound',
}
